import { DnsPropagationStatus } from '@wix/ambassador-premium-domains-v1-connected-domain/types';
import { DomainConnectedStatus } from '../typing/ConnectDomainTypes/connectedDomainSetupConfig';
export const DOMAIN_CONNECTION_STATUSES = {
  [DnsPropagationStatus.COMPLETED]: DomainConnectedStatus.ALREADY_CONNECTED,
  [DnsPropagationStatus.FAILED]: DomainConnectedStatus.CREATE_CONNECT,
  [DnsPropagationStatus.IN_PROGRESS]: DomainConnectedStatus.NEED_MORE_TIME_TO_VERIFY,
  [DnsPropagationStatus.UNKNOWN_DNS_PROPAGATION_STATUS]: DomainConnectedStatus.NEED_MORE_TIME_TO_VERIFY
};
//# sourceMappingURL=connectedDomainSetupConfig.js.map